import React from 'react'
import { staticComponentValueConverter } from '../StaticComponentValues'

function Webview_1({ item }) {
    const customization = staticComponentValueConverter(item?.customization)

    return (
        <iframe onLoad={(e) => e.target.setAttribute("isLoading", "false")} id="mobligo-webview" scrolling="no" src={item?.data?.url} width={"100%"} height={"100%"} className='pointer-events-all no-scrollbar' >

        </iframe>
    )
}

export default Webview_1